import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = async (_route, routerState) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const status = await auth.ensureProbed();

  switch (status) {
    case 'ready':
      return true;

    case 'error':
      return router.createUrlTree(['/errore-servizio']);

    case 'expired':
      return router.createUrlTree(['/sessione-scaduta']);

    case 'anonymous':
    default:
      return router.createUrlTree(['/login'], { queryParams: { returnUrl: routerState.url } });
  }
};
